module.exports = __webpack_public_path__ + "img/star-map-hero-sample-2.8e35303.png";